import { defineComponent as _defineComponent } from 'vue'
import Modal from "@/components/ui/Modal.vue";
  import { reactive, computed, ref } from "vue";
  import useVuelidate from "@vuelidate/core";
  import {
    email,
    helpers,
    required,
    not,
    sameAs,
    numeric,
    minLength,
  } from "@vuelidate/validators";
  import { resetVuelidateErrors } from "@/helpers/vuelidate";
  import Cleave from "vue-cleave-component";
  import { phoneNumberOption } from "@/helpers/cleavePlugin";
  import { validPhoneNumber } from "@/helpers/validation";
  import { trackSendInitialHold } from "@/helpers/initialHold/trackSendInitialHold";
  import store from "@/store";
  import { CreateInitialHoldInterface } from "@/types/InitialHoldInterface";
  import { useToast } from "vue-toastification";
  import axios from "axios";
  import DropDown from "@/components/ui/dropdown/DropDown.vue";
  import { HolderType } from "@/enums/InitialHoldHolderType";
  import { StatesEnum } from "@/enums/StatesEnum";
  import { calculateStateFromPostcode } from "@/helpers/initialHold/calculateStateFromPostcode";
  import { delay } from "@/helpers/async";
  import { LotMapWithLotEstateId } from "@/types/LotMapInterface";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'InitialHoldModal',
  props: {
    isOpen: { type: Boolean, required: true },
    lot: { type: Object as () => LotMapWithLotEstateId, required: true },
    businessId: { type: String, required: false },
  },
  emits: ["send", "back", "close", "toPartnerModal"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

  const userType = ref<string>("");
  const disabled = ref<boolean>(false);
  const toast = useToast();
  const emits = __emit;
  const props = __props;

  const modalContainerRef = ref<HTMLElement | null>(null);
  const contentBlockRef = ref<HTMLElement | null>(null);

  const scrollToBottom = async () => {
    await delay(10);

    if (!contentBlockRef.value || !modalContainerRef.value) return;

    contentBlockRef.value.scrollTo({
      top: modalContainerRef.value.scrollHeight,
      behavior: "smooth",
    });
  };

  const customerIdOrNull = computed(() => {
    return store?.state?.user?.data?._id ? store.state.user.data._id : null;
  });

  const formFields = {
    firstName: "",
    lastName: "",
    phone: "",
    email: "",
    holderType: "Please select" as HolderType,
    postcode: "",
    state: "",
  };

  const form = reactive(Object.assign({}, formFields));
  const rules = {
    firstName: { required },
    lastName: { required },
    phone: {
      required,
      validPhoneNumber: helpers.withMessage(
        "Value must be valid phone number",
        validPhoneNumber
      ),
    },
    holderType: {
      required,
      validValue: not(sameAs("Please select")),
    },
    postcode: { required, numeric, minLength: minLength(4) },
    email: { required, email },
  };

  const v$ = useVuelidate(rules, form);

  function onClose() {
    clearForm();
    resetVuelidateErrors(v$);
    emits("close");
  }

  async function submitForm() {
    v$.value.$touch();
    const isNoErrors = await v$.value.$validate();

    if (!isNoErrors) {
      return;
    }

    const { firstName, lastName, phone, holderType, postcode } = form;
    const leadDetails = {
      email: form.email.toLowerCase(),
      firstName,
      lastName,
      phone,
    };

    const state = calculateStateFromPostcode(postcode);

    createInitialHoldRequest({
      lotId: props.lot.lotId._id,
      lotTitle: props.lot.lotId.title,
      landownerId: props.lot?.landownerId?._id ?? props.lot.lotId.landownerId,
      estateId: props.lot.lotId.estateId,
      businessId: props.businessId,
      leadDetails,
      holderType,
      state,
      postcode,
      ...(customerIdOrNull.value && { customerId: customerIdOrNull.value }),
    });
  }

  const createInitialHoldRequest = (data: CreateInitialHoldInterface) => {
    disabled.value = true;
    store
      .dispatch("initialHold/createInitialHold", data)
      .then(() => {
        emits("send");
        trackSendInitialHold(props.lot.lotId.estateId);
        clearForm();
      })
      .catch(() => {
        toast.error("Something went wrong, please try again later");
      })
      .finally(() => {
        disabled.value = false;
      });
  };

  function clearForm() {
    Object.assign(form, formFields);
    resetVuelidateErrors(v$);
  }
  const onBack = () => {
    if (!userType.value) {
      emits("back");
    }

    userType.value = "";
    resetVuelidateErrors(v$);
    clearForm();
  };

  const selectHolderType = (holderType: HolderType) => {
    form.holderType = holderType;
  };

  const changeForm = () => {
    emits("toPartnerModal");
  };

const __returned__ = { userType, disabled, toast, emits, props, modalContainerRef, contentBlockRef, scrollToBottom, customerIdOrNull, formFields, form, rules, v$, onClose, submitForm, createInitialHoldRequest, clearForm, onBack, selectHolderType, changeForm, Modal, reactive, computed, ref, get useVuelidate() { return useVuelidate }, get email() { return email }, get helpers() { return helpers }, get required() { return required }, get not() { return not }, get sameAs() { return sameAs }, get numeric() { return numeric }, get minLength() { return minLength }, get resetVuelidateErrors() { return resetVuelidateErrors }, get Cleave() { return Cleave }, get phoneNumberOption() { return phoneNumberOption }, get validPhoneNumber() { return validPhoneNumber }, get trackSendInitialHold() { return trackSendInitialHold }, get store() { return store }, get CreateInitialHoldInterface() { return CreateInitialHoldInterface }, get useToast() { return useToast }, get axios() { return axios }, DropDown, get HolderType() { return HolderType }, get StatesEnum() { return StatesEnum }, get calculateStateFromPostcode() { return calculateStateFromPostcode }, get delay() { return delay }, get LotMapWithLotEstateId() { return LotMapWithLotEstateId } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})